import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Logo from "../assets/search.png";
import "./styles.css";
import SearchBar from "./SearchBar";
import { useNavigate,Link } from "react-router-dom";

export default function Contacts({ contacts, changeChat , currentUser}) {
  const [currentUserName, setCurrentUserName] = useState(undefined);
  const [currentUserImage, setCurrentUserImage] = useState(undefined);
  const [currentSelected, setCurrentSelected] = useState(undefined);
  const [searchBar, setSearchBar]=useState(false);

  const navigate = useNavigate();

  const toggleSearchBar = () => {
    setSearchBar(!searchBar);
  };


  useEffect(() => {
      if(currentUser){
        setCurrentUserName(currentUser.username);
        setCurrentUserImage(currentUser.avatarImage);
      }
  }, [currentUser]);

  const changeCurrentChat = (contact) => {
    setCurrentSelected(contact._id);
    changeChat(contact);
  };
  const closeSearchBar = () => {
    setSearchBar(false);
  };
  return (
    <>
      {currentUserImage && currentUserImage && (
        <Container>
          <div className="brand">
          <h3>Toman</h3>
            <button onClick={toggleSearchBar}><img src={Logo} alt="logo" /></button>
            {searchBar && (
        <div className="modal">
          <div onClick={toggleSearchBar} className="overlay"></div>
          <div className="modal-content">
            <SearchBar 
            closeSearchBar={closeSearchBar}
            setCurrentSelected={setCurrentSelected}
            changeChat={changeChat}
            currentUser={currentUser}
            />
          </div>
        </div>
      )}
          </div>
          <div className="contacts">
            {contacts.map((contact, index) => {
              return (
                <div
                  key={contact._id}
                  className={`contact ${
                    contact._id === currentSelected ? "selected" : ""
                  }`}
                  onClick={() => changeCurrentChat(contact)}
                >
                  <div className="avatar">
                    <img
                      src={contact.avatarImage}
                      alt=""
                    />
                  </div>
                  <div className="username">
                    <h3>{contact.username}</h3>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="current-user" onClick={()=>navigate(`/profile/${currentUserName}`)}>
            <div className="avatar">
              <img
                src={currentUserImage}
                alt="avatar"
              />
            </div>
            <div className="username">
              <h2>{currentUserName}</h2>
            </div>
          </div>
        </Container>
      )}
    </>
  );
}
const Container = styled.div`
  display: grid;
  grid-template-rows: 10% 75% 15%;
  overflow: hidden;
  background-color: #424769;
  .brand {
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: center;
    img {
      height: 2rem;
    }
    h3 {
      color: white;
      text-transform: uppercase;
    }
  }
  .contacts {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    gap: 0.8rem;
    &::-webkit-scrollbar {
      width: 0.2rem;
      &-thumb {
        background-color: #ffffff39;
        width: 0.1rem;
        border-radius: 1rem;
      }
    }
    .contact {
      background-color: #ffffff34;
      min-height: 5rem;
      cursor: pointer;
      width: 90%;
      border-radius: 0.2rem;
      padding: 0.4rem;
      display: flex;
      gap: 1rem;
      align-items: center;
      transition: 0.5s ease-in-out;
      .avatar {
        img {
          height: 3rem;
        }
      }
      .username {
        h3 {
          color: white;
        }
      }
    }
    .selected {
      background-color: #9a86f3;
    }
  }

  .current-user {
    background-color: #2D3250;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    cursor:pointer;
    .avatar {
      img {
        height: 4rem;
        max-inline-size: 100%;
      }
    }
    .username {
      h2 {
        color: white;
      }
    }
    @media screen and (min-width: 720px) and (max-width: 1080px) {
      gap: 0.5rem;
      .username {
        h2 {
          font-size: 1rem;
        }
      }
    }
  }
`;
